const CHAT_HISTORY_KEY = 'sealseek_chat_history';
const CHAT_MESSAGES_KEY = 'sealseek_chat_messages';
const CHAT_TITLE_KEY = 'sealseek_chat_title';
const LEGACY_WELCOME_MESSAGE_PREFIXES = [
  '你好！我是玺承SealSeek AI助手。',
  'Hello! I am SealSeek AI Assistant.'
];
const LEGACY_HISTORY_TITLES = new Set([
  '小狗与人类烦恼比较',
  '如何提升企业增长',
  '数据分析方法'
]);

const safeParse = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const normalizeHistoryItem = (item) => {
  if (!item) return null;
  const title = String(item.title || '').trim();
  if (!title) return null;
  return {
    id: String(item.id || Date.now()),
    title,
    createdAt: item.createdAt || new Date().toISOString()
  };
};

const sanitizeHistory = (items) => {
  const uniqueTitles = new Set();
  return items
    .map(normalizeHistoryItem)
    .filter(Boolean)
    .filter((item) => !LEGACY_HISTORY_TITLES.has(item.title))
    .filter((item) => {
      if (uniqueTitles.has(item.title)) return false;
      uniqueTitles.add(item.title);
      return true;
    })
    .slice(0, 30);
};

export const getChatHistory = () => {
  const parsed = safeParse(localStorage.getItem(CHAT_HISTORY_KEY));
  if (!Array.isArray(parsed)) return [];
  const sanitized = sanitizeHistory(parsed);
  // 迁移旧的示例历史数据，避免侧边栏继续显示写死内容
  if (sanitized.length !== parsed.length) {
    localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(sanitized));
  }
  return sanitized;
};

export const saveChatHistory = (items) => {
  const nextItems = Array.isArray(items) ? sanitizeHistory(items) : [];
  localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(nextItems));
  return nextItems;
};

export const addChatHistoryItem = (title) => {
  const normalizedTitle = String(title || '').trim();
  if (!normalizedTitle) return getChatHistory();

  const existing = getChatHistory();
  const next = [
    {
      id: String(Date.now()),
      title: normalizedTitle,
      createdAt: new Date().toISOString()
    },
    ...existing
  ];

  saveChatHistory(next);
  return getChatHistory();
};

const normalizeMessage = (message) => {
  if (!message || !message.text || !message.sender) return null;
  return {
    id: message.id || Date.now(),
    text: String(message.text),
    sender: message.sender,
    timestamp: message.timestamp ? new Date(message.timestamp) : new Date()
  };
};

const isLegacyWelcomeMessage = (message) => {
  const text = String(message?.text || '').trim();
  return message?.sender === 'ai' &&
    LEGACY_WELCOME_MESSAGE_PREFIXES.some((prefix) => text.startsWith(prefix));
};

export const getChatMessages = () => {
  const parsed = safeParse(localStorage.getItem(CHAT_MESSAGES_KEY));
  if (!Array.isArray(parsed)) return [];
  const normalized = parsed
    .map(normalizeMessage)
    .filter(Boolean)
    .filter((message) => !isLegacyWelcomeMessage(message));

  if (normalized.length !== parsed.length) {
    saveChatMessages(normalized);
  }

  return normalized;
};

export const saveChatMessages = (messages) => {
  const normalized = Array.isArray(messages) ? messages.map(normalizeMessage).filter(Boolean) : [];
  const serializable = normalized.map((item) => ({
    ...item,
    timestamp: item.timestamp instanceof Date ? item.timestamp.toISOString() : new Date(item.timestamp).toISOString()
  }));
  localStorage.setItem(CHAT_MESSAGES_KEY, JSON.stringify(serializable));
};

export const getCurrentChatTitle = () => String(localStorage.getItem(CHAT_TITLE_KEY) || '').trim();

export const saveCurrentChatTitle = (title) => {
  const normalizedTitle = String(title || '').trim();
  if (!normalizedTitle) {
    localStorage.removeItem(CHAT_TITLE_KEY);
    return;
  }
  localStorage.setItem(CHAT_TITLE_KEY, normalizedTitle);
};
